import React from 'react';
import { connect } from 'react-redux';
import * as yup from 'yup';
import moment from 'moment';
// import { format } from 'date-fns';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Collapse from '@material-ui/core/Collapse';

import { createSchedule } from '../../store/actions/schedule';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import NameScheduleForm from '../../components/Schedule/NameScheduleForm';
import RotationForm from '../../components/Schedule/RotationForm';
import WeekdayForm from '../../components/Schedule/WeekdayForm';
import { Typography } from '@material-ui/core';
import RotationDialog from '../Schedules/RotationDialog';

const styles = theme => ({
  container: {
    padding: `${theme.spacing(3)}px ${theme.spacing(4)}px`,
  },
  buttons: {
    marginLeft: 'auto',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
});

const steps = ['Nomear Escala', 'Cadastrar Turno'];


const nameScheduleSchema = yup.object().shape({
  description: yup.string().required(),
});

const rotationSchema = yup.object().shape({
  category: yup.string().required(),
  amountWork: yup.string().required(),
  amountLoose: yup.string().required(),
  firstShiftIni: yup.string().matches(/\d\d:\d\d/),
  firstShiftEnd: yup.string().matches(/\d\d:\d\d/),
  secondShiftIni: yup.string().matches(/(\d\d:\d\d)?/),
  secondShiftEnd: yup.string().matches(/(\d\d:\d\d)?/),
});

class CreateSchedule extends React.Component {
  state = {
    activeStep: 0,
    nameScheduleValues: {
      description: '',
      horaryClosing: 'Wed Aug 24 2022 05:30:26 GMT-0300 (Horário Padrão de Brasília)',
      isRotation: false,
      isZeroScale: false
    },
    rotationValues: {
      category: 'DAYS',
      amountWork: null,
      amountLoose: null,
      firstShiftIni: null,
      firstShiftEnd: null,
      secondShiftIni: null,
      secondShiftEnd: null,
    },
    shifts: [],
    modalRotation: false
  };

  getStepContent = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return (
          <Grid item xs={12}>
            <Collapse in appear>
              <NameScheduleForm
                values={this.state.nameScheduleValues}
                handleChange={this.handleInputChange('nameScheduleValues')}
                handleChangeHour={this.handleChangeHorary}
              />
            </Collapse>
          </Grid>
        );
      case 1:
        return (
          <Collapse in appear timeout={800}>
            {this.state.nameScheduleValues.isRotation ? (
              <RotationForm
                values={this.state.rotationValues}
                handleChange={this.handleInputChange('rotationValues')}
                currentName={this.state.nameScheduleValues}
              />
            ) : (
              <WeekdayForm
                values={this.state.nameScheduleValues}
                handleChange={this.handleChangeHoraryClosing}
                shifts={this.state.shifts}
                handleAddShift={this.handleAddShift}
                handleDeleteShift={this.handleDeleteShift}
              />
            )}
          </Collapse>
        );
      default:
        return 'Unknown stepIndex';
    }
  };

  // handleChangeHorary = (event) => {
  //   this.setState({
  //     nameScheduleValues: { ...this.state.nameScheduleValues, horaryClosing: event },
  //   });
  // }

  handleChangeHoraryClosing = (event, type) => {
    let newDateTime = { ...this.state.nameScheduleValues.horaryClosing };
    switch (type) {
      case 'horaryClosing':
        newDateTime = event;
        this.setState({
          nameScheduleValues: { ...this.state.nameScheduleValues, horaryClosing: newDateTime },
        });
        break;
    }
  };

  handleInputChange = name => attribute => (event) => {
    if (event) {
      if (event.target) {
        if (event.target.type === 'checkbox') {
          this.setState({ [name]: { ...this.state[name], [attribute]: event.target.checked } });
        } else {
          this.setState({ [name]: { ...this.state[name], [attribute]: event.target.value } });
        }
      } else {
        this.setState({ [name]: { ...this.state[name], [attribute]: event } });
      }
    }
  };

  handleAddShift = (shift) => {
    this.setState({ shifts: this.state.shifts.concat(shift) });
  };

  handleDeleteShift = (index) => {
    const newShifts = this.state.shifts;
    newShifts.splice(index, 1);
    this.setState({ shifts: newShifts });
  };

  handleRotationInvalid = () => {
    const isValidWorkingDay = (this.state.rotationValues.amountWork === '12' && this.state.rotationValues.amountLoose === '36') ||
      (this.state.rotationValues.amountWork === '12' && this.state.rotationValues.amountLoose === '24') ||
      (this.state.rotationValues.amountWork === '24' && this.state.rotationValues.amountLoose === '48');

    if (!!isValidWorkingDay && this.state.rotationValues.amountWork !== null){
      this.handleNext()
    }else if (!!isValidWorkingDay == false && this.state.rotationValues.amountWork !== null){
      this.setState({modalRotation:true})
    }else{
      this.handleNext()
    }
  }

  handleNext = () => {
    const {
      activeStep, nameScheduleValues, rotationValues, shifts,
    } = this.state;
    const { FromEmployeeRegistry } = this.props;

    if (activeStep === steps.length - 1) {
      let schedule = {};
      // transform moment object in time HH:MM
      if (nameScheduleValues.isRotation) {
        const {
          category, amountWork, amountLoose, ...shiftsTurns
        } = rotationValues;

        shiftsTurns.firstShiftIni = moment(shiftsTurns.firstShiftIni).format('HH:mm');
        shiftsTurns.firstShiftEnd = moment(shiftsTurns.firstShiftEnd).format('HH:mm');
        shiftsTurns.secondShiftIni = shiftsTurns.secondShiftIni
          ? moment(shiftsTurns.secondShiftIni).format('HH:mm')
          : null;
        shiftsTurns.secondShiftEnd = shiftsTurns.secondShiftEnd
          ? moment(shiftsTurns.secondShiftEnd).format('HH:mm')
          : null;

        schedule = {
          workingDay: {
            ...nameScheduleValues,
            horaryClosing: moment(this.state.nameScheduleValues.horaryClosing).format('HH:mm'),
            category,
            amountWork,
            amountLoose,
          },
          shifts: [{ days: [], shiftsTurns: { ...shiftsTurns } }],
        };
      } else {
        schedule = {
          workingDay: { ...nameScheduleValues, horaryClosing: moment(this.state.nameScheduleValues.horaryClosing).format('HH:mm') },
          shifts,
        };
      }

      this.props
        .onCreateSchedule(schedule)
        .then(() => {
          this.props.history.push(FromEmployeeRegistry == true ? '' : '/escalas');
        })
        .catch(error => error);
    } else {
      this.setState({
        activeStep: activeStep + 1,
      });
    }
  };

  handleBack = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep - 1,
    });
  };

  handleClose = () => {
    this.setState({ modalRotation: false })
  }

  isDisabled = () => {
    const {
      activeStep, nameScheduleValues, rotationValues, shifts,
    } = this.state;
    if (activeStep === 0) {
      return !nameScheduleSchema.isValidSync(nameScheduleValues);
    } else if (activeStep === 1 && nameScheduleValues.isRotation) {
      if (rotationValues.firstShiftIni && rotationValues.firstShiftEnd) {
        return false;
      } else {
        return !rotationSchema.isValidSync(rotationValues);
      }
    }
    return !shifts.length;
  };

  render() {
    const { classes, loading, openTour } = this.props;
    const { activeStep } = this.state;

    const buttonName = activeStep === steps.length - 1 ? 'FINALIZAR' : 'PRÓXIMO';

    return (
      <React.Fragment>
        <ContentHeader
          title="Cadastrar escala"
          subtitle="Informe os dados para o cadastro de uma escala"
        >
          <Button color="primary" onClick={openTour} >Está com Duvidas?</Button>
        </ContentHeader>
        <Paper elevation={2}>
          <Stepper activeStep={activeStep}>
            {steps.map(label => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Typography style={{ paddingLeft: '30px' }}> Nome da Escala: {this.state.nameScheduleValues.description}</Typography>

          <Divider />
          <RotationDialog open={this.state.modalRotation} onClose={this.handleClose} onContinue={this.handleNext} />

          <Grid container direction="column" className={classes.container}>
            {this.getStepContent(activeStep)}

            <div className={classes.buttons}>
              <Button
                disabled={activeStep === 0}
                onClick={this.handleBack}
                className={classes.backButton}
              >
                VOLTAR
              </Button>

              <Button
                data-tut="reactour__proximo"
                variant="contained"
                color="primary"
                disabled={loading || this.isDisabled()}
                onClick={this.handleRotationInvalid}
              >
                {loading ? <CircularProgress size={20} color="primary" /> : buttonName}
              </Button>
            </div>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
});

const mapDispatchToProps = dispatch => ({
  onCreateSchedule: schedule => dispatch(createSchedule(schedule)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(CreateSchedule));
